module.exports = __webpack_public_path__ + "static/media/zgrabi-prihodnost.74c71807.png";